import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/internal/operators/map';

@Injectable({
	providedIn: 'root',
})
export class QuestionService {
	constructor(private http: HttpClient) {}

	get Questions$(): Observable<any> {
		return this.http.get<any>(`${environment.apiUrl}/main/questions/`);
	}
	get Phases$(): Observable<any> {
		return this.http.get<any>(`${environment.apiUrl}/main/AdminPhases/`);
	}
	updateQuestion(data): Observable<any> {
		return this.http.post<any>(
			`${environment.apiUrl}/main/UpdateQuestion`,
			data,
		);
	}

	updatePhase(data): Observable<any> {
		return this.http.post<any>(`${environment.apiUrl}/main/UpdatePhase`, data);
	}
}
